import actions from "./moduleAuthActions.js";
import getters from "./moduleAuthGetters.js";
import mutations from "./moduleAuthMutations.js";
import state from "./moduleAuthState.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
